/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RejectChecklistRequest
 */
export interface RejectChecklistRequest {
  /**
   *
   * @type {string}
   * @memberof RejectChecklistRequest
   */
  checklistItemHeaderID?: string;
}

export function RejectChecklistRequestFromJSON(json: any): RejectChecklistRequest {
  return RejectChecklistRequestFromJSONTyped(json, false);
}

export function RejectChecklistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectChecklistRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    checklistItemHeaderID: !exists(json, "checklistItemHeaderID") ? undefined : json["checklistItemHeaderID"],
  };
}

export function RejectChecklistRequestToJSON(value?: RejectChecklistRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    checklistItemHeaderID: value.checklistItemHeaderID,
  };
}
